/* @ngInject */
export function RubricCategoryController ($scope, $translate) {
	$scope.categoryPoints = null;
	$scope.categoryTotal = 0;

	$scope.getCategoryAriaIndex = function () {
		const categoryIndex = ($scope.schema?.elements || [])
			.filter((item) => item.type === 'category')
			.indexOf($scope.element);

		return categoryIndex >= 0 ? categoryIndex + 1 : null;
	};

	$scope.getCategoryTitleAriaLabel = function () {
		const categoryIndex = $scope.getCategoryAriaIndex();
		const label = $scope.element.title || $translate.instant('rubric_aria-category-name');
		return categoryIndex != null ? `${label} ${categoryIndex}` : label;
	};

	$scope.getCategoryDescriptionAriaLabel = function () {
		const categoryIndex = $scope.getCategoryAriaIndex();
		const label = $scope.element.desc || $translate.instant('rubric_aria-category-description');
		return categoryIndex != null ? `${label} ${categoryIndex}` : label;
	};

	/**
	 *  Calculate category total
	 */
	$scope.updateCategoryTotal = function () {
		$scope.categoryTotal = $scope.schema.calculateTotalPoints($scope.element);
	};

	/**
	 * Calculate category points
	 */
	$scope.updateCategoryPoints = function () {
		$scope.categoryPoints = $scope.schema.calculatePointsEarned($scope.element);
	};

	/**
	 * Get score label
	 *
	 * @returns {string}
	 */
	$scope.getScoreLabel = function () {
		let label = '';
		if ($scope.categoryTotal > 0) {
			if (isNaN(parseFloat($scope.categoryPoints))) {
				label = '— / ' + $scope.categoryTotal;
			} else {
				label = $scope.categoryPoints + ' / ' + $scope.categoryTotal;
			}
		}
		return label;
	};

	/**
	 * Whether category points is a negative value
	 *
	 * @returns {boolean}
	 */
	$scope.isCategoryNegative = function () {
		return $scope.categoryPoints < 0;
	};

	/**
	 * Whether category points is a positve value
	 *
	 * @returns {boolean}
	 */
	$scope.isCategoryPositive = function () {
		return parseFloat($scope.categoryPoints) >= 0;
	};

	/**
	 * Schema elements change event handler
	 */
	$scope.$watch('schema.elements', function () {
		$scope.updateCategoryPoints();
		$scope.updateCategoryTotal();
	}, true);
}
